export const LOGIN_MODE = {
	QR: 'QR',
	OTP: 'OTP',
	EMAIL: 'EMAIL',
	AZURE_AD: 'AZURE_AD',
}

export const LS_LOGIN_MODE = {
	QR: 0,
	OTP: 1,
	EMAIL: 2,
	AZURE_AD: 3,
}

export const LS_LOGIN_MODE_NAME = {
	0: 'QR',
	1: 'OTP',
	2: 'EMAIL',
	3: 'AZURE_AD',
}
